module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "career-opportunities"
    }
  }, [_c('h2', [_vm._v("Career Opportunities")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cip.definition))]), _vm._v(" "), (_vm.occupations.length) ? [_c('table', [_vm._m(0), _vm._v(" "), _c('tr', {
    staticClass: "salary-row"
  }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "salary-cell"
  }, [_c('div', {
    staticClass: "salary-scale"
  }, [_c('div', {
    staticClass: "salary-scale-min salary-scale-label"
  }, [_vm._v(_vm._s(_vm.dollars(_vm.salaryMin)))]), _vm._v(" "), _c('div', {
    staticClass: "salary-scale-mid salary-scale-label"
  }, [_vm._v(_vm._s(_vm.dollars(_vm.salaryMid)))]), _vm._v(" "), _c('div', {
    staticClass: "salary-scale-max salary-scale-label"
  }, [_vm._v(_vm._s(_vm.dollars(_vm.salaryMax)))]), _vm._v(" "), _c('div', {
    staticClass: "salary-scale-domain"
  })])])]), _vm._v(" "), _vm._l((_vm.occupations), function(occupation) {
    return (occupation.salary && occupation.tags && occupation.salary.annual_median) ? _c("occupation", {
      key: occupation.code,
      tag: "tr",
      attrs: {
        "occupation": occupation,
        "salary-min": _vm.salaryMin,
        "salary-range": _vm.salaryRange
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "note-everyday"
  }, [_vm._v("\n      Career data obtained from the Occupational Information Network (O*NET).\n      These occupations are identified based on the CIP code for " + _vm._s(_vm.cip.name) + "\n      (" + _vm._s(_vm.cip.code) + "). The salary range depicts the 10th percentile, median, and\n      90th percentile salary values for each occupation.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "job-legend"
  }, [(_vm.showGreenLegend) ? [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n          Green occupations will likely change as a result of the green economy.\n          Green economy activities and technologies are increasing the demand for\n          occupations, shaping the work and worker requirements needed for\n          occupational performance, or generating new and emerging occupations.\n        ")])] : _vm._e(), _vm._v(" "), (_vm.showBrightOutlookLegend) ? [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("\n          Bright Outlook occupations are expected to grow rapidly in the next\n          several years, will have large numbers of job openings, or are new and\n          emerging occupations.\n        ")])] : _vm._e()], 2)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Occupation")]), _vm._v(" "), _c('th', [_vm._v("Median Salary")]), _vm._v(" "), _c('th', {
    staticClass: "salary-cell"
  }, [_vm._v("Salary Range")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-legend-header"
  }, [_c('span', {
    staticClass: "job-legend-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/green_job.png"),
      "height": "24"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "job-legend-label"
  }, [_vm._v("Green Occupation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-legend-header"
  }, [_c('span', {
    staticClass: "job-legend-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/bright_outlook_job.png"),
      "height": "24"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "job-legend-label"
  }, [_vm._v("Bright Outlook")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a6dc774","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/career_opportunities.vue
// module id = 1119
// module chunks = 1